export class InstrumentImpl {
    audioUnit;
    name;
    constructorFn;
    constructor(audioUnit, name, constructorFn) {
        this.audioUnit = audioUnit;
        this.name = name;
        this.constructorFn = constructorFn;
    }
}
